import * as actionTypes from "./constants";

const fetchTripDesignLoadData = (params) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_TRIP_CRUD_LOAD_INIT_ACTION,
      params: params,
    });
  };
};

const fetchVehicleData = (params) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_LOAD_VEHICLE_INIT_ACTION,
      params: params,
    });
  };
};
const fetchDriverData = (params) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_LOAD_DRIVER_INIT_ACTION,
      params: params,
    });
  };
};
const updateSingleLoadData = (params) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_UPDATE_SINGLE_LOAD_DATA_ACTION,
      params: params,
    });
  };
};

const updateTripPlann = (params) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_TRIP_PLAN_CRUD_LOAD_INIT_ACTION,
      params: params,
    });
  };
};

const selectedLoad = (data) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SELECTED_LOAD_INIT_ACTION,
      payload: data,
    });
  };
};

const deleteSelectdLoad = (data) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.DELETE_SELECTED_LOAD_INIT_ACTION,
      payload: data,
    });
  };
};

const updatePlannedTripPlan = (params) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_PLANNED_TRIP_PLAN_CRUD_LOAD_INIT_ACTION,
      params: params,
    });
  };
};

const fetchTripPlanByIdAction = (data) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_TRIP_PLAN_BY_ID_INIT_ACTION,
      payload: data,
    });
  };
};

const fetchLoadByIdsAction = (data) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_LOAD_BY_IDS_INIT_ACTION,
      payload: data,
    });
  };
};

const deleteSelectedTripAction = (data) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.DELETE_PLANNED_SELECTED_TRIP_INIT_ACTION,
      payload: data,
    });
  };
};

const fetchVehicleSubCatAction = (data) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_VEHICLE_SUB_CAT_INIT_ACTION,
      payload: data,
    });
  };
};
const createBidAction = (data) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.CREATE_BID_INIT_ACTION,
      payload: data,
    });
  };
};

const fetchPaymnt = (data) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_PAYMNT_INIT_ACTION,
      payload: data,
    });
  };
};

const clearSelectedList = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.CLEAR_SELECTED_LIST
    })
  }
}

export default {
  fetchTripDesignLoadData,
  fetchVehicleData,
  fetchDriverData,
  updateSingleLoadData,
  updateTripPlann,
  selectedLoad,
  deleteSelectdLoad,
  updatePlannedTripPlan,
  fetchTripPlanByIdAction,
  fetchLoadByIdsAction,
  deleteSelectedTripAction,
  fetchVehicleSubCatAction,
  createBidAction,
  fetchPaymnt,
  clearSelectedList
};
